export default function normalizeLinkedinUrl(linkedin?: string | null) {
	const sanitizedLinkedin = linkedin?.replace(/[`'"\s]+/g, '').trim()

	if (!sanitizedLinkedin) return ''

	if (/^https?:\/\//i.test(sanitizedLinkedin)) {
		return sanitizedLinkedin
	}

	return `https://${sanitizedLinkedin.replace(/^\/+/, '')}`
}
